import { UserPrayScreen } from '@/src/features/message/ui/screens/UserPrayScreen'
import { useNumberLocalSearchParam } from '@/src/general/utils/useNumberLocalSearchParam'

const UserPrayRouterPage = () => {
  const userId = useNumberLocalSearchParam('userId')
  const conversationId = useNumberLocalSearchParam('conversationId')

  // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- userId cannot be undefined in this route
  return <UserPrayScreen userId={userId!} conversationId={conversationId} />
}

export default UserPrayRouterPage
